import Vue from "vue";
import VueRouter from "vue-router";
// import Home from '@/views/Home.vue'
// import Login from '@/views/Login'
import LoginOther from "@/views/LoginOther";
import SysuRegister from "@/views/SysuRegister";
import RegisterSuccess from "@/views/SysuRegister/RegisterSuccess";
import userAuditStatus from "@/views/userAuditStatus";
// import Home from '../views/Home.vue'
// import Register from '../views/Register'
import RegisterOther from "../views/RegisterOther";
import renderNotFound from "../views/renderNotFound";
import { getUrlParams } from "@/utils/util";
import { A_ACCESS_TOKEN, A_TENANT_ID, REGISTER_TENANT_ID, CURRENT_TENANT_ID } from "@/store/mutation-types";
import axios from "axios";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
    // name: 'Home',
    // component: Home
  },
  {
    path: "/login",
    name: "login",
    component: LoginOther,
  },
  {
    path: "/register",
    name: "register",
    component: RegisterOther,
  },
  {
    path: "/:platform/register",
    name: "Register",
    component: SysuRegister,
  },
  {
    path: "/:platform/reRegister/:userName",
    name: "reRegister",
    component: SysuRegister,
  },
  {
    path: "/:platform/registerSuccess",
    name: "RegisterSuccess",
    component: RegisterSuccess,
  },
  {
    path: "/:platform/userAuditStatus",
    name: "userAuditStatus",
    component: userAuditStatus,
  },
  {
    path: "/:platform/userAuditStatus",
    name: "userAuditStatus",
    component: userAuditStatus,
  },
  // 平台信息丢失页
  {
    path: "/renderNotFound",
    name: "renderNotFound",
    component: renderNotFound,
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
const whiteList = [
  "login",
  "mLogin",
  "sysuLogin",
  // 检查地址栏
  "BGWLogin",
  "fwbzLogin",
  "zcptLogin",
  "Register",
  "reRegister",
  "RegisterSuccess",
  "userAuditStatus",
  "register",
  "renderNotFound",
];

// 路由拦截控制
router.beforeEach(async (to, from, next) => {
  // 检查地址栏
  const params = getUrlParams();
  console.log('to_from', to, from, params);
  if (from.name === 'renderNotFound' && Vue.ls.set(CURRENT_TENANT_ID, params.tenantId)) {
    next(to)
  }
  console.log(!params.tenantId && to.name !== 'renderNotFound');
  if (!params.tenantId && to.name !== 'renderNotFound' && from.name !== 'renderNotFound') {
    next({ name: 'renderNotFound' })
    return
  }
  if (params.tenantId) {
    Vue.ls.set(REGISTER_TENANT_ID, params.tenantId)
    Vue.ls.set(CURRENT_TENANT_ID, params.tenantId)
  }
  // 检测登录状态
  const { logout, code, state } = params;
  if (logout || (code && state)) {
    Vue.ls.clear();
  }
  // const aToken = Vue.ls.get(A_ACCESS_TOKEN);
  // const aTenantId = Vue.ls.get(A_TENANT_ID);
  // if (aToken && aTenantId) {
  //   if (!window.urlConfig) {
  //     const res = await axios.get("/globalConfigFriendly.json");
  //     const urlConfig = res.data;
  //     window.urlConfig = urlConfig;
  //   }
  //   if (to.path === "/mLogin") {
  //     window.location.href = `${window.urlConfig.webs.mainUrl}?token=${aToken}&tId=${aTenantId}&redirectUrl=${location.origin}${location.pathname}`;
  //   } else if (to.path === "/sysu/login") {
  //     window.location.href = `${window.urlConfig.webs.mainUrl}?token=${aToken}&tId=${aTenantId}&redirectUrl=${location.origin}${location.pathname}`;
  //   } else if (to.path === "/login") {
  //     const routeParams = getUrlParams();
  //     // 如果路径上有带token的话需要清除token
  //     if (routeParams.token) {
  //       delete routeParams.token;
  //       delete routeParams.tId;
  //     }
  //     const search =
  //       "&" +
  //       Object.entries(routeParams)
  //         .map((i) => `${i[0]}=${encodeURIComponent(i[1])}`)
  //         .join("&");
  //     window.location.href = `${window.urlConfig.webs.mainUrl}?token=${aToken}&tId=${aTenantId}&redirectUrl=${location.origin}${location.pathname}${search}`;
  //   } else {
  //     next({ path: "/login" });
  //   }
  // } else {
  Vue.ls.remove(A_ACCESS_TOKEN);
  Vue.ls.remove(A_TENANT_ID);
  // 无权限跳出去
  if (whiteList.includes(to.name)) {
    next();
  } else {
    next({ path: "/login" });
  }
  // }
});

router.afterEach((to, from) => {
  if (to.meta.title || to.query.title) {
    const title = to.query.title || to.meta.title;
    document.title = title;
  }
});

export default router;
